export const CALCULATOR_EVENTS = {
  TRIGGER_LIMIT: 'trigger_limit',
  CALCULATE_PAYMENT: 'calculate_payment',
  EXPAND_CALCULATOR: 'expand_calculator',
  SHOW_CONTENT: 'show_content',
};
